/*
 * Copyright 2019-2026 Bloomreach
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Typed } from 'emittery';
import { PageModel } from './page';

export const PageEventBusService = Symbol('PageEventBusService');

/**
 * Page model update event.
 */
export interface PageUpdateEvent {
  /**
   * Updated part of the page model.
   */
  page: PageModel;
}

export interface PageEvents {
  'page.update': PageUpdateEvent;
}

export type PageEventBus = Typed<PageEvents>;
